/* Refined — product page behaviour. Matches Refined Store.dc.html (isPdp). */
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  function bind(root) {
  if (!root) return;

  /* 1. Thumbnails: hover on desktop, tap on mobile, swaps the main image */
  const views = root.querySelectorAll('[data-rm-view]');
  const thumbs = root.querySelectorAll('[data-rm-thumb]');
  const show = (i) => {
    views.forEach(v => v.classList.toggle('is-active', v.dataset.rmView === i));
    thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.rmThumb === i));
  };
  thumbs.forEach(t => {
    t.addEventListener('mouseenter', () => show(t.dataset.rmThumb));
    t.addEventListener('click', () => show(t.dataset.rmThumb));
  });

  /* 2. Stars under the title: jump to the reviews block */
  const toReviews = root.querySelector('[data-rm-to-reviews]');
  const reviews = root.querySelector('#rm-reviews');
  if (toReviews && reviews) {
    toReviews.addEventListener('click', (e) => {
      e.preventDefault();
      const y = reviews.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'auto' });
    });
  }

  /* 3. Size pills + quantity update the hidden variant id and the buy label */
  const form = root.querySelector('[data-rm-form]');
  const idInput = root.querySelector('[data-rm-variant-id]');
  const qtyInput = root.querySelector('[data-rm-qty-input]');
  const cta = root.querySelector('[data-rm-cta]');
  const fmt = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',');
  let price = null;
  const activeSize = root.querySelector('.rm-pill--size.is-active');
  if (activeSize) price = parseInt(activeSize.dataset.price, 10);
  const refreshCta = () => {
    if (!cta || cta.disabled || price === null) return;
    const q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    cta.textContent = 'buy ' + cta.dataset.name + ' · ' + fmt(price * q);
  };
  root.querySelectorAll('[data-rm-size]').forEach(b => {
    b.addEventListener('click', () => {
      if (b.disabled) return;
      root.querySelectorAll('[data-rm-size]').forEach(x => x.classList.remove('is-active'));
      b.classList.add('is-active');
      idInput.value = b.dataset.rmSize;
      price = parseInt(b.dataset.price, 10);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', b.dataset.rmSize);
      window.history.replaceState({}, '', url);
      refreshCta();
    });
  });
  root.querySelectorAll('[data-rm-qty]').forEach(b => {
    b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.rmQty, 10));
      refreshCta();
    });
  });
  if (qtyInput) qtyInput.addEventListener('input', refreshCta);

  /* 4. Complete your ritual: arrows jump one page (no smooth scroll: it gets dropped with scroll-snap) */
  const rail = root.querySelector('[data-rm-ritual-rail]');
  root.querySelectorAll('[data-rm-ritual]').forEach(b => {
    b.addEventListener('click', () => {
      if (!rail) return;
      const dir = parseInt(b.dataset.rmRitual, 10);
      const max = rail.scrollWidth - rail.clientWidth;
      const target = Math.max(0, Math.min(max, Math.round(rail.scrollLeft + dir * (rail.clientWidth + 12))));
      rail.style.scrollSnapType = 'none';
      rail.scrollLeft = target;
      requestAnimationFrame(() => { rail.style.scrollSnapType = 'x mandatory'; });
    });
  });

  /* 5. "Make it a set" from the ritual cards: AJAX-adds the clicked set,
     then opens + refreshes Horizon's cart drawer the same way the PDP's
     main add-to-cart does (CartLinesUpdateEvent contract, as before).
     New: if a loose matcha or tool (the same trigger products the cart
     drawer's own "make your set complete" upsell watches for) is already
     in the cart, that line gets swapped out for the set instead of just
     adding alongside it — same swap mechanic as rm-cart-upsell.liquid,
     reusing its trigger handle list since metafields aren't available
     from cart.js's plain item data. */
  const RM_TRIGGER_HANDLES = [
    'ceremonial-matcha-30g',
    'ceremonial-matcha-50g',
    'purple-matcha-whisk',
    'bamboo-scoop',
    'metal-measurement-scoop',
    'ceramic-bowl',
    'whisk-holder',
  ];
  const refreshCart = () => {
    const cartItemsComponent = document.querySelector('cart-items-component');
    if (cartItemsComponent && typeof cartItemsComponent.fetchCartData === 'function') {
      return customElements.whenDefined('cart-items-component').then(() => cartItemsComponent.fetchCartData());
    }
    return fetch(Theme.routes.cart_url + '.json', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then((response) => response.json());
  };
  root.querySelectorAll('[data-rm-quick-add]').forEach(b => {
    b.addEventListener('click', () => {
      if (b.disabled) return;
      b.disabled = true;
      const variantId = parseInt(b.dataset.rmQuickAdd, 10);
      const deferred = CartLinesUpdateEvent.createPromise();

      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise: deferred.promise,
        })
      );

      fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          const triggerItem = cart.items.find((item) => RM_TRIGGER_HANDLES.includes(item.handle));
          return fetch(Theme.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) throw new Error(response.message || 'Add to cart failed');
              if (!triggerItem) return;
              return fetch(Theme.routes.cart_change_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: triggerItem.key, quantity: 0 }),
              });
            });
        })
        .then(() => refreshCart())
        .then((ajaxCart) => {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
            detail: {
              items: ajaxCart.items,
              source: 'rm-product-ritual',
              itemCount: 1,
              didError: false,
            },
          });
          b.textContent = 'added ✓';
          b.disabled = false;
        })
        .catch((error) => {
          console.error('[rm-product] make it a set failed', error);
          deferred.reject(error);
          b.disabled = false;
        });
    });
  });

  /* 6. Ticket add-ons: opt-in checkboxes (data-rm-addon-toggle) offering
     discounted matcha sizes alongside an event ticket. Left unchecked,
     the form submits exactly as it always has — nothing below ever runs
     and nothing is added to the cart on its own. Mutually exclusive
     (checking one unchecks the others) since this is "pick your size",
     not "stack every size". Checked, the submit is intercepted and every
     line (ticket + whichever add-on is checked) is AJAX-added together
     in one go, reusing the same CartLinesUpdateEvent/cart-drawer-refresh
     contract as "make it a set" above. The actual €10 price drop happens
     at checkout via the "Event ticket upsell" automatic discount in
     Admin — this only ever adds the add-on product at its normal price. */
  const addonToggles = Array.from(root.querySelectorAll('[data-rm-addon-toggle]'));
  if (addonToggles.length > 1) {
    addonToggles.forEach((toggle) => {
      toggle.addEventListener('change', () => {
        if (!toggle.checked) return;
        addonToggles.forEach((other) => {
          if (other !== toggle) other.checked = false;
        });
      });
    });
  }
  if (addonToggles.length && form) {
    form.addEventListener('submit', (e) => {
      const checkedAddons = addonToggles.filter((t) => t.checked);
      if (!checkedAddons.length) return;
      e.preventDefault();
      if (cta && cta.disabled) return;
      if (cta) cta.disabled = true;

      const ticketVariantId = parseInt(idInput.value, 10);
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      const addonLines = checkedAddons.map((t) => ({
        merchandiseId: parseInt(t.dataset.rmAddonVariantId, 10),
        quantity: 1,
      }));
      const deferred = CartLinesUpdateEvent.createPromise();

      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: ticketVariantId, quantity: qty }].concat(addonLines),
          promise: deferred.promise,
        })
      );

      const items = [{ id: ticketVariantId, quantity: qty }].concat(
        checkedAddons.map((t) => ({ id: parseInt(t.dataset.rmAddonVariantId, 10), quantity: 1 }))
      );

      fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.message || 'Add to cart failed');
          return refreshCart();
        })
        .then((ajaxCart) => {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
            detail: {
              items: ajaxCart.items,
              source: 'rm-product-ticket-addon',
              itemCount: qty + checkedAddons.length,
              didError: false,
            },
          });
          if (cta) cta.disabled = false;
        })
        .catch((error) => {
          console.error('[rm-product] ticket add-on failed', error);
          deferred.reject(error);
          if (cta) cta.disabled = false;
        });
    });
  }

  /* 7. Size and grade siblings (30g/50g, no.1/no.2, etc.) are separate
     products, linked via plain <a href> — swap the page content in place
     instead of a full navigation, so switching doesn't reset scroll. */
  root.querySelectorAll('a.rm-pill--size[href], a.rm-pill--grade[href]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const url = a.getAttribute('href');
      if (!url || url === window.location.pathname) return;
      e.preventDefault();
      swapPdp(url, true);
    });
  });
  }

  function swapPdp(url, pushState) {
    return fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = doc.querySelector('[data-rm-pdp]');
        const oldRoot = document.querySelector('[data-rm-pdp]');
        if (!newRoot || !oldRoot) {
          window.location.href = url;
          return;
        }
        oldRoot.replaceWith(newRoot);
        document.title = doc.title;
        if (pushState) window.history.pushState({ rmPdp: true }, '', url);
        bind(newRoot);
      })
      .catch(() => {
        window.location.href = url;
      });
  }

  window.addEventListener('popstate', (e) => {
    if (!document.querySelector('[data-rm-pdp]')) return;
    swapPdp(window.location.href, false);
  });

  bind(document.querySelector('[data-rm-pdp]'));
})();
